<template>
  <div class="summary-container">
    <div class="agreement-container">
      <h2>Contract Upload</h2>
      <p>Please upload your signed contract.</p>

      <form>
        <div class="kyc-row">
          <div class="contract-row">
            <h4>Upload signed contract</h4>
            <div class="image-upload">
              <p class="image-name">{{ s3image }}</p>
              <input
                class="image-upload-button"
                type="file"
                id="file"
                ref="moi_file"
                @change="uploadImageToS3"
                accept="application/pdf, application/msword, .doc, .docx"
              />
              <label for="file">
                <a-spin :spinning="spinnings" /> Upload Contract</label
              >
            </div>
          </div>
        </div>
      </form>
      <div>
        <button @click="submitContract" class="download-button" type="button">
          Submit
        </button>
      </div>
    </div>

    <!-- Illustration -->
    <div class="illustration">
      <div class="description">
        Kindly upload your signed contract of agreement.
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />

      <img :src="require('../../../../assets/img/female-wave.gif')" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LOAgreement",
  props: ["updateStatus", "updateTracker", "markAsCompleted", "productPackage"],
  data() {
    return {
      checkAgreement: false,
      agreementCount: 1,
      s3image: "",
      spinnings: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    processCustomerProduct() {
      const HTTP = this.$httpUtils.FASTHTTP;

      const data = {
        ...this.productPackage,
        monthlyIncomeRange: "4",
        employmentStatus: "0"
      };
      console.log("now on payment summary >>>>>>>>>>>>>>>>>>>>>>>>>>>>>", data);

      HTTP.get(`/productoption/productoption`)
        .then(res => {
          if (res.data === null) {
            HTTP.post(`/productoption/productoption`, data)
              .then(response => {
                console.log("This is a console logggggg", response.data);
                if (response.status) this.handleNext();
                else this.showErrorMsg({ message: response.data.message });
              })
              .catch(error =>
                this.showErrorMsg({
                  message: error.response.data.detail
                })
              );
          } else if (!res.data.isPurchased) {
            HTTP.patch(`/productoption/nextproductionoption`, data)
              .then(result => {
                if (result.status) this.handleNext();
                else this.showErrorMsg({ message: result.data.message });
              })
              .catch(err =>
                this.showErrorMsg({ message: err.response.data.detail })
              );
          }
        })
        .catch(err => console.log(err));

      // if (this.loSection === "/onboarding/lo/job-info") {
      //   if (
      //     this.employmentPackage.monthlyIncomeRange &&
      //     this.employmentPackage.employmentStatus
      //   ) {
      //     this.saveCustomerProduct(data);
      //   } else this.showErrorMsg({ message: "Please fill all fields!" });
      // } else this.saveCustomerProduct(data);
    },
    uploadImageToS3(event) {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      this.spinnings = true;
      this.showInfoMsg({ message: "Uploading File" });
      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.post("/kycfiles/s3-file-upload", formData).then(res => {
        this.spinnings = true;
        if (res && res.data && res.data.url) {
          this.spinnings = false;
          this.s3image = res.data.url;
          this.showSuccessMsg({ message: "File successfully uploaded" });
        } else {
          this.spinnings = false;
          this.showErrorMsg({ message: "File upload not successful" });
        }
      });
    },
    submitContract() {}
  },
  mounted() {
    this.updateTracker(true);
    this.updateStatus(3);
    this.processCustomerProduct();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h2,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
  font-weight: 700;
}

h4 {
  width: 327px;
  font-weight: 700;
  font-size: 16px;
  color: #fe7a11;
  margin: 20px 0px 20px;
  // flex: 1;
}

.summary-container {
  display: flex;
  justify-content: space-between;
}

.agreement-container {
  margin-top: 18px;
  padding: 30px 0;

  h2 {
    margin-bottom: 18px;
  }
}

.contract-row {
  display: flex;
  justify-content: space-between;
  margin: 32px auto;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}

.kyc-row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.image-upload {
  display: flex;
  justify-content: flex-end;
  background: #fafafa;
  margin-left: 24px;
  border-radius: 3px;
  border: none;
  width: 100%;
  padding: 17px;
  height: 65px;
}

.image-upload-button {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}

.image-upload label {
  box-shadow: 2px 2px 5px 2px #888888;
  padding: 8px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  font-family: "DM Sans";
  font-style: normal;
  color: #727272;
  margin-left: 10px;
}

.image-name {
  max-width: 180px;
  overflow: hidden;
  padding: 7px;
  height: 30px;
}

.summary {
  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;
    width: 70%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/LOAgreement.vue